import { render, staticRenderFns } from "./competition-3.vue?vue&type=template&id=bd74b354&scoped=true&"
import script from "./competition-3.vue?vue&type=script&lang=js&"
export * from "./competition-3.vue?vue&type=script&lang=js&"
import style0 from "./competition-3.vue?vue&type=style&index=0&id=bd74b354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd74b354",
  null
  
)

export default component.exports